import contentMainTemplate from './content_main.html';
// Used to load the application's content. It uses ng-include.
angular.module('BBPublicBooking').directive('bbContentNew', (PathSvc) => {
        return {
            restrict: 'A',
            replace: true,
            scope: true,
            templateUrl: PathSvc.directivePartial(contentMainTemplate.id.replace('.html', '')),
            controller($scope){
                $scope.initPage = () => $scope.$eval('setPageLoaded()');
            }
        };
    }
);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/content-new/bb_content_new.directive.js